export default `
    <div id="#= data.id #" class="#= data.classes || "" # #=data.bsc||""#">
    </div>
`;
